"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _base = _interopRequireDefault(require("./base"));
var _useFetchIcon = _interopRequireDefault(require("./use-fetch-icon.js"));
const _excluded = ["icon"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * Asynchronously loads and renders icons by name.
 *
 * @param {object} props
 * @param {object} props.icon - The name of the icon to render.
 * @returns {React.ReactElement | null}
 */
function AsyncIcon(_ref) {
  let {
      icon
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    iconContent
  } = (0, _useFetchIcon.default)(icon, {
    cdn: 'https://img6.wsimg.com/ux-assets/@ux/icon/5.0.0'
  });
  if (!iconContent) {
    return null;
  }
  const IconComponent = getIconComponent(icon);
  return /*#__PURE__*/_react.default.createElement(IconComponent, props);
}
AsyncIcon.propTypes = {
  icon: _propTypes.default.string.isRequired
};
const iconComponentCache = new Map();

/**
 * Get the <IconComponent /> from the cache or create a new one.
 *
 * @param {string} icon - Name of the icon
 * @returns {React.Component} - the <IconComponent />
 */
function getIconComponent(icon) {
  const iconComponent = iconComponentCache.get(icon);
  if (iconComponent) {
    return iconComponent;
  }
  const newIconComponent = (0, _base.default)(icon);
  iconComponentCache.set(icon, newIconComponent);
  return newIconComponent;
}
var _default = exports.default = AsyncIcon;